<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <!-- Desktop menu items ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
        <div class="desktop-sidebar-items">
          <sidebar-item :link="{
            name: 'داشبورد',
            path: '/dashboard',
            icon: 'fas fa-shopping-bag'
          }"></sidebar-item>

          <sidebar-item :link="{
            name: 'کاربران',

            icon: 'fas fa-users'
          }">
            <sidebar-item :link="{
              name: 'همه کاربران',
              path: '/users/all',
              icon: 'fas fa-shopping-bag'
            }"></sidebar-item>

            <sidebar-item :link="{
                name: 'مدارک در انتظار تایید ',
                path: '/users/document',
                icon: 'fas fa-shopping-bag',
              }"></sidebar-item>

            <sidebar-item :link="{
                name: 'اطلاعات اولیه در انتظار تایید',
                path: '/users/personal-info',
                icon: 'fas fa-shopping-bag',
              }"></sidebar-item>

            <sidebar-item :link="{
                name: 'آدرس های در انتظار تایید',
                path: '/users/addresses',
                icon: 'fas fa-shopping-bag',
              }"></sidebar-item>

            <sidebar-item
              v-if="checkAccessIbanPending"
              :link="{
                name: 'شبا های تائید نشده',
                path: '/iban',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="checkAccessIbanPending"
              :link="{
                name: 'کارت های تائید نشده',
                path: '/cards',
              }"
            ></sidebar-item>

          </sidebar-item>

          <sidebar-item :link="{
            name: 'پشتیبانی',
            icon: 'fas fa-envelope-open-text'
          }">
            <sidebar-item :link="{
              name: 'همه تیکت ها',
              path: '/support',
              icon: 'fas fa-shopping-bag'
            }"></sidebar-item>

            <sidebar-item :link="{
              name: 'دپارتمان ها',
              path: '/support-departments',
              icon: 'fas fa-shopping-bag'
            }"></sidebar-item>

            <!-- <sidebar-item
              :link="{
                name: 'تیکت های پاسخ داده شده',
                path: '/users/waiting',
                icon: 'fas fa-shopping-bag',
              }"
            ></sidebar-item> -->
          </sidebar-item>

          <sidebar-item :link="{
              name: 'گزارشات',
              icon: 'fas fa-list',
            }">
            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'موجودی سیستم',
                path: '/reports/user-balances',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'برداشت های ناموفق تومانی',
                path: '/reports/open-withdrawals',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'برداشت های ناموفق پرفکت مانی',
                path: '/reports/prefect-money-open-withdrawals',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'تراکنش های درگاه',
                path: '/reports/fiat-transaction',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'واریز و برداشت های کریپتو',
                path: '/reports/transactions',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'تریدها',
                path: '/reports/orders',
              }"
            />

            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'جوایز',
                path: '/reports/reward',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'پرفکت مانی',
                path: '/reports/perfect-money',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'گردگیری',
                path: '/reports/dusting',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'خریدوفروش',
                path: '/reports/totals',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'واریز های بانکی',
                path: '/reports/manual-fiat-deposit',
              }"
            ></sidebar-item>

            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'تراکنش های دستی',
                path: '/reports/manual-balance-change',
              }"
            ></sidebar-item>

          </sidebar-item>

          <sidebar-item :link="{
              path:'/reward-center',
              name: 'سرویس جایزه ها',
              icon: 'fa fa-gift'
            }">

            <sidebar-item
              class="mb-0"
              :link="{
              name: 'جایزه ها',
              path:'/reward-center/rewards',
            }"
            >
              <sidebar-item
                class="mb-0"
                :link="{
                  name: 'ایجاد',
                  path:'/reward-center/rewards/create',
                }"
              />
              <sidebar-item :link="{
                name: 'لیست ',
                path:'/reward-center/rewards/list',
               }" />
              <sidebar-item :link="{
                 name: 'لیست شروط',
                 path:'/reward-center/rewards/conditions',
               }" />
            </sidebar-item>

            <sidebar-item
              class="mb-0"
              :link="{
              name: 'جوایز دریافت شده',
              path:'/reward-center/achieved-rewards',
            }"
            >
              <sidebar-item
                class="mb-0"
                :link="{
                  name: 'محاسبه شده ها',
                  path:'/reward-center/achieved-rewards/calculated',
                }"
              />
              <sidebar-item :link="{
                name: 'تایید شده ها',
                path:'/reward-center/achieved-rewards/confirmed',
               }" />
              <sidebar-item :link="{
                 name: 'پرداخت شده ها',
               path:'/reward-center/achieved-rewards/paid',
               }" />

            </sidebar-item>

            <sidebar-item :link="{
            name: 'خزانه',
            path: '/treasury',
            icon: 'fa fa-credit-card'
          }"></sidebar-item>

            <sidebar-item :link="{
                 name: 'اختصاص جایزه',
               path:'/reward-center/add-reward-to-user',
               }" />

          </sidebar-item>

          <sidebar-item :link="{
              name: 'تنظیمات',
              icon: 'fas fa-cog'
              }">
            <sidebar-item :link="{
                  name: 'مدیریت ارز ها',
                  path: '/setting/assets',
                  icon: 'fas fa-gear'
               }" />

            <sidebar-item :link="{
              name: 'تنظیمات قیمت',
              path: '/setting/prices',
              icon: 'fas fa-shopping-bag'
            }"></sidebar-item>

            <sidebar-item :link="{
              name: 'پشتیبان ها',
              path: '/interview/agents',
              icon: 'fas fa-gear'
            }"></sidebar-item>

            <sidebar-item :link="{
              name: 'تنظیمات قرار',
              path: '/interview/setting',
              icon: 'fas fa-shopping-bag'
            }"></sidebar-item>
            <sidebar-item :link="{
                name: 'تنظیمات ووچر',
                path: '/setting/voucher',
                icon: 'fas fa-shopping-bag',
              }"></sidebar-item>
            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'تنظیمات عملیات',
                path: '/setting/operations',
                icon: 'fas fa-shopping-bag',
              }"
            ></sidebar-item>
            <sidebar-item
              v-if="isSuperAdmin"
              :link="{
                name: 'تنظیمات اطلاعیه',
                path: '/setting/announcement',
                icon: 'fas fa-shopping-bag',
              }"
            ></sidebar-item>
          </sidebar-item>
        </div>
        <!--End Desktop menu items ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
      </template>
    </side-bar>

    <curtain-menu
      :user="user"
      :show="true"
    ></curtain-menu>

    <div class="notification-sidebar">
      <b-sidebar
        no-header
        header-class="notification-sidebar-header"
        id="sidebar-backdrop"
        title="اعلان ها"
        backdrop-variant="dark"
        bg-variant="white"
        backdrop
        shadow
        width="460"
      >
        <div class="notification-sidebar-header">
          <div
            style="padding: 0"
            class="col-1"
          >
            <b-icon
              v-b-toggle.sidebar-backdrop
              icon="x"
              scale="2"
              class="close-icon"
            ></b-icon>
          </div>
          <div
            style="padding: 0"
            class="col-6"
          >
            <h3 class="notification-sidebar-header-title">اعلان ها</h3>
          </div>
          <div
            style="padding: 0"
            class="col-lg-5 col-0 select-box"
          >
            <div class="notification-sidebar-header-select-container">
              <b-form-select
                v-model="selectedFilter"
                :options="options"
                class="notification-sidebar-header-select"
                plain
                @change="changeFilter()"
              ></b-form-select>
            </div>
          </div>

          <div
            style="padding: 0"
            class="col-5 col-lg-0 dropdown-box"
          >
            <div class="notification-sidebar-header-select-container">
              <div>
                <b-form-select
                  v-model="selectedFilter"
                  :options="options"
                  class="notification-sidebar-header-select"
                  plain
                  @change="changeFilter()"
                ></b-form-select>
              </div>
            </div>
          </div>
        </div>
        <div class="notification-sidebar-body">
          <b-skeleton-table
            v-if="loading"
            :rows="15"
            :columns="2"
            :table-props="{ bordered: true, striped: true }"
          >
          </b-skeleton-table>
          <b-list-group
            v-if="selectedFilter == null && !loading"
            class="notification-items-container"
          >
            <b-list-group-item
              class="flex-column align-items-start notification-items"
              v-for="(message, index) in messages"
              :key="index"
            >
              <div class="d-flex w-100 justify-content-between">
                <h5 class="title">
                  {{ getNotificationMessage(message).title }}
                  <b-icon
                    class="icon-button"
                    font-scale="0.9"
                    :icon="message.seen == false ? 'eye' : 'eye-fill'"
                    @click="setSeen(message.id)"
                  ></b-icon>
                </h5>

                <small class="date">
                  <b-icon
                    class="icon-button"
                    font-scale="0.9"
                    icon="x-circle-fill"
                    @click="deletMessage(message.id)"
                  >
                  </b-icon>
                </small>
              </div>

              <p class="text">
                {{ getNotificationMessage(message).message }}
              </p>

              <b-link
                v-if="getNotificationMessage(message).path"
                :to="getNotificationMessage(message).path"
                class="link"
              >{{ getNotificationMessage(message).pathname }}

                <b-icon
                  icon="chevron-left"
                  class="bi-chevron-left"
                ></b-icon>
              </b-link>
            </b-list-group-item>
          </b-list-group>
          <b-list-group
            v-if="selectedFilter != null"
            class="notification-items-container"
          >
            <b-list-group-item
              class="flex-column align-items-start notification-items"
              v-for="(message, index) in filteredMessages"
              :key="index"
            >
              <div class="d-flex w-100 justify-content-between">
                <h5 class="title">
                  {{ getNotificationMessage(message).title }}
                  <b-icon
                    class="icon-button"
                    font-scale="0.9"
                    :icon="message.seen == false ? 'eye' : 'eye-fill'"
                    @click="setSeen(message.id)"
                  ></b-icon>
                </h5>

                <small class="date">
                  <b-icon
                    class="icon-button"
                    font-scale="0.9"
                    icon="x-circle-fill"
                    @click="deletMessage(message.id)"
                  >
                  </b-icon>
                </small>
              </div>

              <p class="text">
                {{ getNotificationMessage(message).message }}
              </p>

              <b-link
                v-if="getNotificationMessage(message).path"
                :to="getNotificationMessage(message).path"
                class="link"
              >{{ getNotificationMessage(message).pathname }}

                <b-icon
                  icon="chevron-left"
                  class="bi-chevron-left"
                ></b-icon>
              </b-link>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-sidebar>
    </div>
    <div class="main-content main-content-without-tabs">
      <dashboard-navbar
        :user="user"
        :type="$route.meta.navbarType"
      ></dashboard-navbar>

      <div>
        <fade-transition
          :duration="200"
          origin="center top"
          mode="out-in"
        >
          <router-view></router-view>
        </fade-transition>
      </div>
      <!-- <content-footer v-if="!$route.meta.hideFooter"></content-footer> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "@/assets/css/layout/layout.scss";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

// function initScrollbar(className) {
//   if (hasElement(className)) {
//     new PerfectScrollbar(`.${className}`);
//   } else {
//     // try to init it later in case this component is loaded async
//     setTimeout(() => {
//       initScrollbar(className);
//     }, 100);
//   }
// }

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";
import CurtainMenu from "../../components/CurtainMenuPlugin/CurtainMenu";
import http from "@/httpservices/HttpService";
import store from "@/store";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
    CurtainMenu,
  },

  data() {
    return {
      user: {
        name: "",
        level: 1,
        balance: 25640000000,
        currentBuyLevel: 23000000,
        buyLimit: 25000000,
        currentBuyLevelPercentage: 70,
        amountToNextLevel: 2000000,
      },
      show: false,
      loading: false,

      userBoxArrow: "chevron-down",
      selectedFilter: null,
      filteredMessages: [],
      options: [
        {
          value: null,
          text: "همه پیغام ها",
        },
        {
          value: "read",
          text: "خوانده شده",
        },
        {
          value: "unread",
          text: "خوانده نشده",
        },
      ],
      messages: [],
    };
  },

  beforeCreate() {},

  mounted() {
    this.$nextTick(async () => {
      this.$store.getters;
      if (!this.$store.getters.isLoggedIn) {
        router.push("login");
      }
      this.getProfile();
      this.getNotifications();
      this.$store.dispatch("getAssets");
      this.$store.dispatch("getRoles");
    });
  },

  computed: {
    checkAccessIbanPending() {
      return Boolean(
        store.getters["isSuperAdmin"] ||
          store.getters["ManagerAdmin"] ||
          store.getters["ApprovingManager"]
      );
    },
    isSuperAdmin() {
      return Boolean(store.getters["isSuperAdmin"]);
    },
  },

  methods: {
    getNotificationMessage(message) {
      const date = new Date(this.fixDate(message.created)).toLocaleString(
        "fa-ir",
        {
          timeZone: "Asia/Tehran",
        }
      );
      if (message.type == "LoginRequest") {
        return {
          title: "ورود به سیستم",
          path: "",
          pathname: "",
          message: `ورود به سیستم در تاریخ: ${date}.`,
        };
      } else if (message.type == "DocumentApproval") {
        // return "تایید مدارک احراز هویت";
        return {
          title: "ورود به سیستم",
          path: "",
          pathname: "",
          message: `ورود به سیستم در تاریخ: ${date}.`,
        };
      } else if (message.type == "DocumentRejection") {
        //return "رد مدارک احراز هویت";
        return {
          title: "ورود به سیستم",
          path: "",
          pathname: "",
          message: `ورود به سیستم در تاریخ: ${date}.`,
        };
      } else if (message.type == "Deposit") {
        return {
          title: "تراکنش واریز",
          path: "/history/all-irt",
          pathname: "سوابق تراکنش‌ها",
          message: `تراکنش واریز در تاریخ ${date}`,
        };
      } else if (message.type == "Withdraw") {
        return {
          title: "تراکنش برداشت",
          path: "/history/all-irt",
          pathname: "سوابق تراکنش‌ها",
          message: `:تراکنش برداشت در تاریخ ${date}`,
        };
      } else if (message.type == "PasswordRecovery") {
        return {
          title: "تغیر رمز عبور",
          path: "",
          message: `:تغیر رمز عبور در تاریخ ${date}`,
        };
      } else if (message.type == "TicketOpen") {
        return {
          title: "ارسال تیکت",
          path: "/support/1",
          pathname: "پشتیبانی",
          message: `:ارسال تیکت در تاریخ ${date}`,
        };
      } else if (message.type == "TicketClose") {
        return {
          title: "بسته شدن تیکت",
          path: "/support/1",
          pathname: "پشتیبانی",
          message: `:بسته شدن تیکت در تاریخ ${date}`,
        };
      } else if (message.type == "TicketReply") {
        return {
          title: "دریافت پاسخ تیکت",
          path: "/support/1",
          pathname: "پشتیبانی",
          message: `:دریافت پاسخ تیکت در تاریخ ${date}`,
        };
      }
    },

    getProfile() {
      this.show = false;
      const token = localStorage.getItem("token") || "";

      http
        .get("/Accounts/")
        .then((response) => {
          if (response.data.firstName != null) {
            this.user.name =
              response.data.firstName + " " + response.data.lastName;
            this.user.level = response.data.role;
          } else {
            this.user.name = response.data.cellPhone.number;
          }

          this.show = true;
        })
        .catch((err) => {
          this.show = true;
          //console.log(err);
          //this.$router.push("/500");
        });
    },

    deletMessage(id) {
      const token = this.$store.getters.token || "";

      http
        .delete("/Notifications/" + id)
        .then(() => {
          this.getNotifications();
        })
        .catch((err) => {
          console.log(err);

          //this.$router.push("/500");
        });
    },

    setSeen(id) {
      this.loading = true;
      const token = this.$store.getters.token || "";

      http
        .put("/Notifications/" + id)
        .then(() => {
          this.getNotifications();
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          //this.$router.push("/500");
        });
    },

    changeFilter(filter) {
      if (this.selectedFilter == "read") {
        this.filteredMessages = [];
        this.messages.forEach((element) => {
          if (element.seen) {
            this.filteredMessages.push(element);
          }
        });
      } else if (this.selectedFilter == "unread") {
        this.filteredMessages = [];
        this.messages.forEach((element) => {
          if (!element.seen) {
            this.filteredMessages.push(element);
          }
        });
      }
    },

    getNotifications() {
      this.loading = true;
      const token = localStorage.getItem("token") || "";

      http
        .get("/Notifications")
        .then((response) => {
          this.messages = response.data;

          // this.$store.dispatch(
          //   "setNotSeen",
          //   this.messages.filter(el => !el.seen).length
          // );
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.icon-button {
  cursor: pointer;
}

input {
  color: rgb(0, 0, 0) !important;
}

.main-content-without-tabs {
  @media (max-width: 991px) {
    padding-top: 56px !important;
  }

  @media (min-width: 991px) {
    padding-top: 61px !important;
  }
}

.main-content-with-tabs {
  @media (max-width: 991px) {
    padding-top: 56px !important;
  }

  @media (min-width: 991px) {
    padding-top: 170px !important;
  }
}

@media (max-width: 768px) {
  .card-body {
    padding-right: 8px;
    padding-left: 8px;
  }
}
</style>
